import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const NewArrivalsBanner = () => {
  return (
    <motion.div
      initial={{ x: -30, opacity: 0 }}
      whileInView={{ x: 0, opacity: 1 }}
      viewport={{ once: false, amount: 0.4 }}
      transition={{
        type: "spring",
        duration: 1,
        
      }}
    >
      <Component>
        <img
          src="https://m.media-amazon.com/images/I/810aSvR+0FL._AC_SX679_.jpg"
          alt=""
        />
        <Overlay />

        <OverlayWritings>
          <Backdroptext>
            <p>
              {" "}
              <span>M</span>atrix
            </p>
          </Backdroptext>
          <h4>#newarrivals</h4>
          <p
            style={{ letterSpacing: "10px", marginTop: "10px", color: "black" }}
          >
            E-COMMERCE SITE
          </p>
          <p style={{ textDecoration: "underline", color: "black" }}>
            shop now
          </p>
        </OverlayWritings>
      </Component>
    </motion.div>
  );
};

export default NewArrivalsBanner;

const Component = styled.div`
  position: relative;
  width: 95%;
  margin: 40px auto;
  height: 70vh;
  background-color: #fff;
  img {
    position: absolute;
    z-index: 1;
    height: 100%;
    object-fit: contain;
    right: 20px;
  }
`;

const Overlay = styled.div`
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.2);
`;

const OverlayWritings = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 4;
  color: white;
  width: 50vw;
  top: 0;
  left: 0;
  bottom: 0;
  h4 {
    background-color: black;
  }
`;

const Backdroptext = styled.div`
  position: absolute;
  z-index: -1;
  font-weight: 1000;
  letter-spacing: 20px;
  font-family: sans-serif;
  font-size: 70px;
  p {
  }
  span {
    transform: rotate(30deg);
  }
  color: #dedede;
`;
